//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { ProcesControleClientBase } from "./procescontroleclientbase";

export class BusinessRulesClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    getBusinessRules(): Promise<BusinessRule[]> {
        let url_ = this.baseUrl + "/api/BusinessRules/GetBusinessRules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBusinessRules(_response);
        });
    }

    protected processGetBusinessRules(response: Response): Promise<BusinessRule[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BusinessRule.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessRule[]>(null as any);
    }

    updateBusinessRule(id: number, businessRuleDto: BusinessRuleDto): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessRules/UpdateBusinessRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessRuleDto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateBusinessRule(_response);
        });
    }

    protected processUpdateBusinessRule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    createBusinessRule(businessRuleDto: BusinessRuleDto): Promise<BusinessRule> {
        let url_ = this.baseUrl + "/api/BusinessRules/CreateBusinessRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(businessRuleDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateBusinessRule(_response);
        });
    }

    protected processCreateBusinessRule(response: Response): Promise<BusinessRule> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = BusinessRule.fromJS(resultData201);
            return result201;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BusinessRule>(null as any);
    }

    deleteBusinessRule(id: number): Promise<void> {
        let url_ = this.baseUrl + "/api/BusinessRules/DeleteBusinessRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteBusinessRule(_response);
        });
    }

    protected processDeleteBusinessRule(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class Client extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    index(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ControleExpeditieClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    getLocations(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ControleExpeditie/GetLocations";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLocations(_response);
        });
    }

    protected processGetLocations(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getAfdelingen(): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ControleExpeditie/GetAfdelingen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAfdelingen(_response);
        });
    }

    protected processGetAfdelingen(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getFilteredData(expeditieDto: ControleExpeditieForListDto): Promise<ControleExpeditiePageDto> {
        let url_ = this.baseUrl + "/api/ControleExpeditie/GetFilteredData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(expeditieDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilteredData(_response);
        });
    }

    protected processGetFilteredData(response: Response): Promise<ControleExpeditiePageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ControleExpeditiePageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleExpeditiePageDto>(null as any);
    }
}

export class ControleKubusClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    get(): Promise<ControleKubus[]> {
        let url_ = this.baseUrl + "/api/ControleKubus/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ControleKubus[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControleKubus.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleKubus[]>(null as any);
    }
}

export class ControleOpenstaandClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    get(): Promise<ControleOpenstaand[]> {
        let url_ = this.baseUrl + "/api/ControleOpenstaand/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ControleOpenstaand[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControleOpenstaand.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleOpenstaand[]>(null as any);
    }
}

export class ControleOpgelostClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    get(): Promise<ControleOpgelost[]> {
        let url_ = this.baseUrl + "/api/ControleOpgelost/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<ControleOpgelost[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControleOpgelost.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleOpgelost[]>(null as any);
    }
}

export class ControlePrestatiesClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    getPickerPrestatieRegels(): Promise<ControlePrestaties[]> {
        let url_ = this.baseUrl + "/api/ControlePrestaties/GetPickerPrestatieRegels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPickerPrestatieRegels(_response);
        });
    }

    protected processGetPickerPrestatieRegels(response: Response): Promise<ControlePrestaties[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlePrestaties.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControlePrestaties[]>(null as any);
    }

    getKubusPrestatieRegels(): Promise<ControlePrestaties[]> {
        let url_ = this.baseUrl + "/api/ControlePrestaties/GetKubusPrestatieRegels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKubusPrestatieRegels(_response);
        });
    }

    protected processGetKubusPrestatieRegels(response: Response): Promise<ControlePrestaties[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlePrestaties.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControlePrestaties[]>(null as any);
    }

    getPackagerPrestatieRegels(): Promise<ControlePrestaties[]> {
        let url_ = this.baseUrl + "/api/ControlePrestaties/GetPackagerPrestatieRegels";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPackagerPrestatieRegels(_response);
        });
    }

    protected processGetPackagerPrestatieRegels(response: Response): Promise<ControlePrestaties[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControlePrestaties.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControlePrestaties[]>(null as any);
    }
}

export class ControleVoorraadClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    getPlanten(): Promise<ControleVoorraad[]> {
        let url_ = this.baseUrl + "/api/ControleVoorraad/GetPlanten";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPlanten(_response);
        });
    }

    protected processGetPlanten(response: Response): Promise<ControleVoorraad[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControleVoorraad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleVoorraad[]>(null as any);
    }

    getBloemen(): Promise<ControleVoorraad[]> {
        let url_ = this.baseUrl + "/api/ControleVoorraad/GetBloemen";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetBloemen(_response);
        });
    }

    protected processGetBloemen(response: Response): Promise<ControleVoorraad[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ControleVoorraad.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ControleVoorraad[]>(null as any);
    }
}

export class ApiClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    health(): Promise<any> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHealth(_response);
        });
    }

    protected processHealth(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }
}

export class ReviewClient extends ProcesControleClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "https://localhost:44391";
    }

    create(reviewedDto: ReviewedRegelsDto): Promise<void> {
        let url_ = this.baseUrl + "/api/Review/Create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reviewedDto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BusinessRule implements IBusinessRule {
    id!: number;
    orderStatusId!: OrderStatus;
    startDate!: Date;
    endDate!: Date;
    value!: number;

    constructor(data?: IBusinessRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.orderStatusId = _data["orderStatusId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BusinessRule {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["orderStatusId"] = this.orderStatusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IBusinessRule {
    id: number;
    orderStatusId: OrderStatus;
    startDate: Date;
    endDate: Date;
    value: number;
}

export enum OrderStatus {
    Onbekend = "Onbekend",
    VoorraadBloemen = "VoorraadBloemen",
    VoorraadPlanten = "VoorraadPlanten",
    Kubus = "Kubus",
    Inpak = "Inpak",
    Expeditie = "Expeditie",
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

export class BusinessRuleDto implements IBusinessRuleDto {
    orderStatusId!: OrderStatus;
    startDate!: Date;
    endDate!: Date;
    value!: number;

    constructor(data?: IBusinessRuleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderStatusId = _data["orderStatusId"];
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : <any>undefined;
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BusinessRuleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BusinessRuleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderStatusId"] = this.orderStatusId;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["value"] = this.value;
        return data;
    }
}

export interface IBusinessRuleDto {
    orderStatusId: OrderStatus;
    startDate: Date;
    endDate: Date;
    value: number;
}

export class ControleExpeditiePageDto implements IControleExpeditiePageDto {
    expeditieRows!: ControleExpeditie[];
    nextPage!: number;

    constructor(data?: IControleExpeditiePageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.expeditieRows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["expeditieRows"])) {
                this.expeditieRows = [] as any;
                for (let item of _data["expeditieRows"])
                    this.expeditieRows!.push(ControleExpeditie.fromJS(item));
            }
            this.nextPage = _data["nextPage"];
        }
    }

    static fromJS(data: any): ControleExpeditiePageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControleExpeditiePageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.expeditieRows)) {
            data["expeditieRows"] = [];
            for (let item of this.expeditieRows)
                data["expeditieRows"].push(item.toJSON());
        }
        data["nextPage"] = this.nextPage;
        return data;
    }
}

export interface IControleExpeditiePageDto {
    expeditieRows: ControleExpeditie[];
    nextPage: number;
}

export class ControleExpeditie implements IControleExpeditie {
    banduitgang!: string;
    debiteurnummer!: string;
    vPartijnummer!: number;
    pickLocatie!: string;
    hub!: string;
    afdeling!: string;
    omschrijving!: string;
    stuks!: number;
    lengte!: number;
    kolli!: number;
    kolliInhoud!: number;
    los?: number | undefined;
    boxNumbers!: string;
    picktijd!: Date;
    inpaktijd!: Date;
    scanKubusIntijd!: Date;
    orderStatus!: OrderStatusEnum;
    kleurStatus!: KleurStatusEnum;

    constructor(data?: IControleExpeditie) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.banduitgang = _data["banduitgang"];
            this.debiteurnummer = _data["debiteurnummer"];
            this.vPartijnummer = _data["vPartijnummer"];
            this.pickLocatie = _data["pickLocatie"];
            this.hub = _data["hub"];
            this.afdeling = _data["afdeling"];
            this.omschrijving = _data["omschrijving"];
            this.stuks = _data["stuks"];
            this.lengte = _data["lengte"];
            this.kolli = _data["kolli"];
            this.kolliInhoud = _data["kolliInhoud"];
            this.los = _data["los"];
            this.boxNumbers = _data["boxNumbers"];
            this.picktijd = _data["picktijd"] ? new Date(_data["picktijd"].toString()) : <any>undefined;
            this.inpaktijd = _data["inpaktijd"] ? new Date(_data["inpaktijd"].toString()) : <any>undefined;
            this.scanKubusIntijd = _data["scanKubusIntijd"] ? new Date(_data["scanKubusIntijd"].toString()) : <any>undefined;
            this.orderStatus = _data["orderStatus"];
            this.kleurStatus = _data["kleurStatus"];
        }
    }

    static fromJS(data: any): ControleExpeditie {
        data = typeof data === 'object' ? data : {};
        let result = new ControleExpeditie();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["banduitgang"] = this.banduitgang;
        data["debiteurnummer"] = this.debiteurnummer;
        data["vPartijnummer"] = this.vPartijnummer;
        data["pickLocatie"] = this.pickLocatie;
        data["hub"] = this.hub;
        data["afdeling"] = this.afdeling;
        data["omschrijving"] = this.omschrijving;
        data["stuks"] = this.stuks;
        data["lengte"] = this.lengte;
        data["kolli"] = this.kolli;
        data["kolliInhoud"] = this.kolliInhoud;
        data["los"] = this.los;
        data["boxNumbers"] = this.boxNumbers;
        data["picktijd"] = this.picktijd ? this.picktijd.toISOString() : <any>undefined;
        data["inpaktijd"] = this.inpaktijd ? this.inpaktijd.toISOString() : <any>undefined;
        data["scanKubusIntijd"] = this.scanKubusIntijd ? this.scanKubusIntijd.toISOString() : <any>undefined;
        data["orderStatus"] = this.orderStatus;
        data["kleurStatus"] = this.kleurStatus;
        return data;
    }
}

export interface IControleExpeditie {
    banduitgang: string;
    debiteurnummer: string;
    vPartijnummer: number;
    pickLocatie: string;
    hub: string;
    afdeling: string;
    omschrijving: string;
    stuks: number;
    lengte: number;
    kolli: number;
    kolliInhoud: number;
    los?: number | undefined;
    boxNumbers: string;
    picktijd: Date;
    inpaktijd: Date;
    scanKubusIntijd: Date;
    orderStatus: OrderStatusEnum;
    kleurStatus: KleurStatusEnum;
}

export enum OrderStatusEnum {
    Onbekend = "Onbekend",
    VoorraadBloemen = "VoorraadBloemen",
    VoorraadPlanten = "VoorraadPlanten",
    Kubus = "Kubus",
    Inpak = "Inpak",
    Expeditie = "Expeditie",
}

export enum KleurStatusEnum {
    Empty = "Empty",
    Red = "Red",
    Yellow = "Yellow",
    DarkRed = "DarkRed",
    Orange = "Orange",
}

export class ControleExpeditieForListDto implements IControleExpeditieForListDto {
    page!: number;
    selectedLocations!: string[];
    selectedAfdelingen!: string[];
    filter!: string;

    constructor(data?: IControleExpeditieForListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.selectedLocations = [];
            this.selectedAfdelingen = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.page = _data["page"];
            if (Array.isArray(_data["selectedLocations"])) {
                this.selectedLocations = [] as any;
                for (let item of _data["selectedLocations"])
                    this.selectedLocations!.push(item);
            }
            if (Array.isArray(_data["selectedAfdelingen"])) {
                this.selectedAfdelingen = [] as any;
                for (let item of _data["selectedAfdelingen"])
                    this.selectedAfdelingen!.push(item);
            }
            this.filter = _data["filter"];
        }
    }

    static fromJS(data: any): ControleExpeditieForListDto {
        data = typeof data === 'object' ? data : {};
        let result = new ControleExpeditieForListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["page"] = this.page;
        if (Array.isArray(this.selectedLocations)) {
            data["selectedLocations"] = [];
            for (let item of this.selectedLocations)
                data["selectedLocations"].push(item);
        }
        if (Array.isArray(this.selectedAfdelingen)) {
            data["selectedAfdelingen"] = [];
            for (let item of this.selectedAfdelingen)
                data["selectedAfdelingen"].push(item);
        }
        data["filter"] = this.filter;
        return data;
    }
}

export interface IControleExpeditieForListDto {
    page: number;
    selectedLocations: string[];
    selectedAfdelingen: string[];
    filter: string;
}

export class ControleKubus implements IControleKubus {
    barcode!: number;
    sourceCode!: string;
    orderStatus!: OrderStatusEnum;
    debiteurnummer!: string;
    omschrijving!: string;
    stuksTotaal!: number;
    stuksAfgerond!: number;
    picker!: string;
    pickTijd!: Date;
    businessRuleAfgegaan!: boolean;
    aantal!: number;
    pickLocatie!: string;
    laan!: string;
    scanKubusIn!: Date;
    scanKubusOut!: Date;
    scanLastKubusEmptied!: Date;
    vPartijnummer!: number;
    lengte!: number;

    constructor(data?: IControleKubus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.sourceCode = _data["sourceCode"];
            this.orderStatus = _data["orderStatus"];
            this.debiteurnummer = _data["debiteurnummer"];
            this.omschrijving = _data["omschrijving"];
            this.stuksTotaal = _data["stuksTotaal"];
            this.stuksAfgerond = _data["stuksAfgerond"];
            this.picker = _data["picker"];
            this.pickTijd = _data["pickTijd"] ? new Date(_data["pickTijd"].toString()) : <any>undefined;
            this.businessRuleAfgegaan = _data["businessRuleAfgegaan"];
            this.aantal = _data["aantal"];
            this.pickLocatie = _data["pickLocatie"];
            this.laan = _data["laan"];
            this.scanKubusIn = _data["scanKubusIn"] ? new Date(_data["scanKubusIn"].toString()) : <any>undefined;
            this.scanKubusOut = _data["scanKubusOut"] ? new Date(_data["scanKubusOut"].toString()) : <any>undefined;
            this.scanLastKubusEmptied = _data["scanLastKubusEmptied"] ? new Date(_data["scanLastKubusEmptied"].toString()) : <any>undefined;
            this.vPartijnummer = _data["vPartijnummer"];
            this.lengte = _data["lengte"];
        }
    }

    static fromJS(data: any): ControleKubus {
        data = typeof data === 'object' ? data : {};
        let result = new ControleKubus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["sourceCode"] = this.sourceCode;
        data["orderStatus"] = this.orderStatus;
        data["debiteurnummer"] = this.debiteurnummer;
        data["omschrijving"] = this.omschrijving;
        data["stuksTotaal"] = this.stuksTotaal;
        data["stuksAfgerond"] = this.stuksAfgerond;
        data["picker"] = this.picker;
        data["pickTijd"] = this.pickTijd ? this.pickTijd.toISOString() : <any>undefined;
        data["businessRuleAfgegaan"] = this.businessRuleAfgegaan;
        data["aantal"] = this.aantal;
        data["pickLocatie"] = this.pickLocatie;
        data["laan"] = this.laan;
        data["scanKubusIn"] = this.scanKubusIn ? this.scanKubusIn.toISOString() : <any>undefined;
        data["scanKubusOut"] = this.scanKubusOut ? this.scanKubusOut.toISOString() : <any>undefined;
        data["scanLastKubusEmptied"] = this.scanLastKubusEmptied ? this.scanLastKubusEmptied.toISOString() : <any>undefined;
        data["vPartijnummer"] = this.vPartijnummer;
        data["lengte"] = this.lengte;
        return data;
    }
}

export interface IControleKubus {
    barcode: number;
    sourceCode: string;
    orderStatus: OrderStatusEnum;
    debiteurnummer: string;
    omschrijving: string;
    stuksTotaal: number;
    stuksAfgerond: number;
    picker: string;
    pickTijd: Date;
    businessRuleAfgegaan: boolean;
    aantal: number;
    pickLocatie: string;
    laan: string;
    scanKubusIn: Date;
    scanKubusOut: Date;
    scanLastKubusEmptied: Date;
    vPartijnummer: number;
    lengte: number;
}

export class ControleOpenstaand implements IControleOpenstaand {
    barcode!: number;
    sourceCode!: string;
    orderStatus!: OrderStatusEnum;
    banduitgang!: string;
    debiteurnummer!: string;
    hub!: string;
    afdeling!: string;
    omschrijving!: string;
    stuks!: number;
    lengte!: number;
    kolli!: number;
    kolliInhoud!: number;
    los?: number | undefined;
    picktijd!: Date;
    inpaktijd!: Date;
    businessRuleAfgegaan!: boolean;

    constructor(data?: IControleOpenstaand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.sourceCode = _data["sourceCode"];
            this.orderStatus = _data["orderStatus"];
            this.banduitgang = _data["banduitgang"];
            this.debiteurnummer = _data["debiteurnummer"];
            this.hub = _data["hub"];
            this.afdeling = _data["afdeling"];
            this.omschrijving = _data["omschrijving"];
            this.stuks = _data["stuks"];
            this.lengte = _data["lengte"];
            this.kolli = _data["kolli"];
            this.kolliInhoud = _data["kolliInhoud"];
            this.los = _data["los"];
            this.picktijd = _data["picktijd"] ? new Date(_data["picktijd"].toString()) : <any>undefined;
            this.inpaktijd = _data["inpaktijd"] ? new Date(_data["inpaktijd"].toString()) : <any>undefined;
            this.businessRuleAfgegaan = _data["businessRuleAfgegaan"];
        }
    }

    static fromJS(data: any): ControleOpenstaand {
        data = typeof data === 'object' ? data : {};
        let result = new ControleOpenstaand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["sourceCode"] = this.sourceCode;
        data["orderStatus"] = this.orderStatus;
        data["banduitgang"] = this.banduitgang;
        data["debiteurnummer"] = this.debiteurnummer;
        data["hub"] = this.hub;
        data["afdeling"] = this.afdeling;
        data["omschrijving"] = this.omschrijving;
        data["stuks"] = this.stuks;
        data["lengte"] = this.lengte;
        data["kolli"] = this.kolli;
        data["kolliInhoud"] = this.kolliInhoud;
        data["los"] = this.los;
        data["picktijd"] = this.picktijd ? this.picktijd.toISOString() : <any>undefined;
        data["inpaktijd"] = this.inpaktijd ? this.inpaktijd.toISOString() : <any>undefined;
        data["businessRuleAfgegaan"] = this.businessRuleAfgegaan;
        return data;
    }
}

export interface IControleOpenstaand {
    barcode: number;
    sourceCode: string;
    orderStatus: OrderStatusEnum;
    banduitgang: string;
    debiteurnummer: string;
    hub: string;
    afdeling: string;
    omschrijving: string;
    stuks: number;
    lengte: number;
    kolli: number;
    kolliInhoud: number;
    los?: number | undefined;
    picktijd: Date;
    inpaktijd: Date;
    businessRuleAfgegaan: boolean;
}

export class ControleOpgelost implements IControleOpgelost {
    barcode!: number;
    sourceCode!: string;
    orderStatusId!: number;
    orderStatus!: string;
    banduitgang!: string;
    debiteurnummer!: string;
    hub!: string;
    afdeling!: string;
    omschrijving!: string;
    stuks!: number;
    lengte!: number;
    kolli!: number;
    kolliInhoud!: number;
    los?: number | undefined;
    picktijd!: Date;
    inpaktijd!: Date;
    user!: string;

    constructor(data?: IControleOpgelost) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.sourceCode = _data["sourceCode"];
            this.orderStatusId = _data["orderStatusId"];
            this.orderStatus = _data["orderStatus"];
            this.banduitgang = _data["banduitgang"];
            this.debiteurnummer = _data["debiteurnummer"];
            this.hub = _data["hub"];
            this.afdeling = _data["afdeling"];
            this.omschrijving = _data["omschrijving"];
            this.stuks = _data["stuks"];
            this.lengte = _data["lengte"];
            this.kolli = _data["kolli"];
            this.kolliInhoud = _data["kolliInhoud"];
            this.los = _data["los"];
            this.picktijd = _data["picktijd"] ? new Date(_data["picktijd"].toString()) : <any>undefined;
            this.inpaktijd = _data["inpaktijd"] ? new Date(_data["inpaktijd"].toString()) : <any>undefined;
            this.user = _data["user"];
        }
    }

    static fromJS(data: any): ControleOpgelost {
        data = typeof data === 'object' ? data : {};
        let result = new ControleOpgelost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["sourceCode"] = this.sourceCode;
        data["orderStatusId"] = this.orderStatusId;
        data["orderStatus"] = this.orderStatus;
        data["banduitgang"] = this.banduitgang;
        data["debiteurnummer"] = this.debiteurnummer;
        data["hub"] = this.hub;
        data["afdeling"] = this.afdeling;
        data["omschrijving"] = this.omschrijving;
        data["stuks"] = this.stuks;
        data["lengte"] = this.lengte;
        data["kolli"] = this.kolli;
        data["kolliInhoud"] = this.kolliInhoud;
        data["los"] = this.los;
        data["picktijd"] = this.picktijd ? this.picktijd.toISOString() : <any>undefined;
        data["inpaktijd"] = this.inpaktijd ? this.inpaktijd.toISOString() : <any>undefined;
        data["user"] = this.user;
        return data;
    }
}

export interface IControleOpgelost {
    barcode: number;
    sourceCode: string;
    orderStatusId: number;
    orderStatus: string;
    banduitgang: string;
    debiteurnummer: string;
    hub: string;
    afdeling: string;
    omschrijving: string;
    stuks: number;
    lengte: number;
    kolli: number;
    kolliInhoud: number;
    los?: number | undefined;
    picktijd: Date;
    inpaktijd: Date;
    user: string;
}

export class ControlePrestaties implements IControlePrestaties {
    rol!: string;
    regelsTotaal!: number;
    regelsVerwerkt!: number;
    score!: number;
    regelsIngepakt!: number;
    scoreIngepakt!: number;

    constructor(data?: IControlePrestaties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rol = _data["rol"];
            this.regelsTotaal = _data["regelsTotaal"];
            this.regelsVerwerkt = _data["regelsVerwerkt"];
            this.score = _data["score"];
            this.regelsIngepakt = _data["regelsIngepakt"];
            this.scoreIngepakt = _data["scoreIngepakt"];
        }
    }

    static fromJS(data: any): ControlePrestaties {
        data = typeof data === 'object' ? data : {};
        let result = new ControlePrestaties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rol"] = this.rol;
        data["regelsTotaal"] = this.regelsTotaal;
        data["regelsVerwerkt"] = this.regelsVerwerkt;
        data["score"] = this.score;
        data["regelsIngepakt"] = this.regelsIngepakt;
        data["scoreIngepakt"] = this.scoreIngepakt;
        return data;
    }
}

export interface IControlePrestaties {
    rol: string;
    regelsTotaal: number;
    regelsVerwerkt: number;
    score: number;
    regelsIngepakt: number;
    scoreIngepakt: number;
}

export class ControleVoorraad implements IControleVoorraad {
    vPartijnummer!: number;
    debiteurnummer!: string;
    omschrijving!: string;
    kolli!: number;
    kolliInhoud!: number;
    los?: number | undefined;
    stuks!: number;
    lengte!: number;
    customerOrderAmount!: number;
    binnenTijdKubus!: Date;
    kleurStatus!: KleurStatusEnum;

    constructor(data?: IControleVoorraad) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vPartijnummer = _data["vPartijnummer"];
            this.debiteurnummer = _data["debiteurnummer"];
            this.omschrijving = _data["omschrijving"];
            this.kolli = _data["kolli"];
            this.kolliInhoud = _data["kolliInhoud"];
            this.los = _data["los"];
            this.stuks = _data["stuks"];
            this.lengte = _data["lengte"];
            this.customerOrderAmount = _data["customerOrderAmount"];
            this.binnenTijdKubus = _data["binnenTijdKubus"] ? new Date(_data["binnenTijdKubus"].toString()) : <any>undefined;
            this.kleurStatus = _data["kleurStatus"];
        }
    }

    static fromJS(data: any): ControleVoorraad {
        data = typeof data === 'object' ? data : {};
        let result = new ControleVoorraad();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vPartijnummer"] = this.vPartijnummer;
        data["debiteurnummer"] = this.debiteurnummer;
        data["omschrijving"] = this.omschrijving;
        data["kolli"] = this.kolli;
        data["kolliInhoud"] = this.kolliInhoud;
        data["los"] = this.los;
        data["stuks"] = this.stuks;
        data["lengte"] = this.lengte;
        data["customerOrderAmount"] = this.customerOrderAmount;
        data["binnenTijdKubus"] = this.binnenTijdKubus ? this.binnenTijdKubus.toISOString() : <any>undefined;
        data["kleurStatus"] = this.kleurStatus;
        return data;
    }
}

export interface IControleVoorraad {
    vPartijnummer: number;
    debiteurnummer: string;
    omschrijving: string;
    kolli: number;
    kolliInhoud: number;
    los?: number | undefined;
    stuks: number;
    lengte: number;
    customerOrderAmount: number;
    binnenTijdKubus: Date;
    kleurStatus: KleurStatusEnum;
}

export class ReviewedRegelsDto implements IReviewedRegelsDto {
    status!: StatusEnum;
    reviewedOrderProcesControleRows!: ReviewedRegelDto[];

    constructor(data?: IReviewedRegelsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.reviewedOrderProcesControleRows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            if (Array.isArray(_data["reviewedOrderProcesControleRows"])) {
                this.reviewedOrderProcesControleRows = [] as any;
                for (let item of _data["reviewedOrderProcesControleRows"])
                    this.reviewedOrderProcesControleRows!.push(ReviewedRegelDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReviewedRegelsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewedRegelsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        if (Array.isArray(this.reviewedOrderProcesControleRows)) {
            data["reviewedOrderProcesControleRows"] = [];
            for (let item of this.reviewedOrderProcesControleRows)
                data["reviewedOrderProcesControleRows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReviewedRegelsDto {
    status: StatusEnum;
    reviewedOrderProcesControleRows: ReviewedRegelDto[];
}

export enum StatusEnum {
    Onbekend = "Onbekend",
    Opgelost = "Opgelost",
    Openstaand = "Openstaand",
    UitgeslotenVoorKubus = "UitgeslotenVoorKubus",
}

export class ReviewedRegelDto implements IReviewedRegelDto {
    barcode!: number;
    sourceCode!: string;
    orderStatus!: OrderStatusEnum;

    constructor(data?: IReviewedRegelDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.barcode = _data["barcode"];
            this.sourceCode = _data["sourceCode"];
            this.orderStatus = _data["orderStatus"];
        }
    }

    static fromJS(data: any): ReviewedRegelDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReviewedRegelDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["barcode"] = this.barcode;
        data["sourceCode"] = this.sourceCode;
        data["orderStatus"] = this.orderStatus;
        return data;
    }
}

export interface IReviewedRegelDto {
    barcode: number;
    sourceCode: string;
    orderStatus: OrderStatusEnum;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}